import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
  //@ts-ignore
  import VuePlyr from 'vue-plyr'
  import Hls from 'hls.js'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import type { Nullable } from '@/services/interfaces/QuizQuestion'
  import useSegment from '@/composables/useSegment'
  import useCourse from '@/composables/useCourse'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AudioPlayer',
  props: {
    audioSource: {
      type: String,
      required: true,
    },
    trackPlayEvents: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

const props = __props;

  

  const audioPlayer = ref(null as Nullable<HTMLDivElement>)
  const audioSourceEl = ref(null as Nullable<HTMLSourceElement>)
  const loading = ref(true)

  const hls = new Hls()

  const { course, currentModule, currentLesson } = useCourse()
  const { audioPlayStarted, audioPlayPaused, audioPlayCompleted } = useSegment()

  const options = {
    autoplay: false,
    muted: false,
    captions: {
      active: true,
      language: 'de',
      update: true,
    },
    controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'settings'],
    speed: {
      selected: 1,
      options: [1, 1.25, 1.5],
    },
    tooltips: { controls: true, seek: true },
  }

  const player = computed(() => (audioPlayer.value as any)?.player)

  const trackAudioEvent = (event: 'play' | 'pause' | 'completed') => {
    if (props.trackPlayEvents && course.value?.id && currentModule.value?.id && currentLesson.value?.id) {
      switch (event) {
        case 'play':
          audioPlayStarted(course.value.id, currentModule.value.id, currentLesson.value.id)
          return
        case 'pause':
          audioPlayPaused(course.value.id, currentModule.value.id, currentLesson.value.id)
          return
        case 'completed':
          audioPlayCompleted(course.value.id, currentModule.value.id, currentLesson.value.id)
          return
        default:
          return
      }
    }
  }

  const handleAudioPlaying = () => {
    trackAudioEvent('play')
  }

  const handleAudioPaused = () => {
    trackAudioEvent('pause')
  }

  const handleAudioPlayCompleted = () => {
    trackAudioEvent('completed')
  }

  const bindPlayerEvents = () => {
    player.value.on('play', handleAudioPlaying)
    player.value.on('pause', handleAudioPaused)
    player.value.on('ended', handleAudioPlayCompleted)
  }

  const unbindPlayerEvents = () => {
    player.value.off('playing', handleAudioPlaying)
    player.value.off('pause', handleAudioPaused)
    player.value.off('ended', handleAudioPlayCompleted)
  }

  const bootstrapAudioPlayer = () => {
    if (Hls.isSupported() && hls) {
      hls.loadSource(props.audioSource)
      hls.attachMedia(player.value.media)
      ;(window as any).hls = hls
    } else {
      const sourceEl = audioSourceEl.value as HTMLSourceElement
      sourceEl.src = props.audioSource
    }
  }

  onMounted(() => {
    bindPlayerEvents()

    const intervalId = window.setInterval(async () => {
      const data = await fetch(props.audioSource!)
      if (data.status === 200) {
        window.clearInterval(intervalId)
        bootstrapAudioPlayer()
        loading.value = false
      }
    }, 1000)
  })

  onBeforeUnmount(() => {
    unbindPlayerEvents()

    if (Hls.isSupported() && hls) {
      hls.detachMedia()
      hls.destroy()
    }
  })

return { __sfc: true,props, audioPlayer, audioSourceEl, loading, hls, course, currentModule, currentLesson, audioPlayStarted, audioPlayPaused, audioPlayCompleted, options, player, trackAudioEvent, handleAudioPlaying, handleAudioPaused, handleAudioPlayCompleted, bindPlayerEvents, unbindPlayerEvents, bootstrapAudioPlayer, computed, onBeforeUnmount, onMounted, ref, VuePlyr, Hls, LoadingSpinner, useSegment, useCourse }
}

})